const vClickOutside = {
    mounted(el, binding) {
        el.clickOutsideEvent = event => {
            const rect = el.getBoundingClientRect();
            const isInElement =
                event.clientX >= rect.left &&
                event.clientX <= rect.right &&
                event.clientY >= rect.top &&
                event.clientY <= rect.bottom;

            if (!isInElement) {
                binding.value(event, el);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unmounted(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    },
};

export default vClickOutside;